import { MissionGroupType } from '@web/gql/graphql'
import nClicks from '@web/libs/nlog/click/codes'
import { isMediaReviewMissionGroup } from '@web/pages/mission/components/MissionActivityCard/PhotoReviewMissionCard/PhotoReviewMissionCard.helper'

import { MissionCard, MissionCardProps } from '../MissionCard/MissionCard'
import LotteryReceiptReviewMissionCard from './LotteryReceiptReviewMissionCard/LotteryReceiptReviewMissionCard'
import PhotoReviewMissionCard from './PhotoReviewMissionCard/PhotoReviewMissionCard'
import PlaceCategoryReviewMissionCard from './PlaceCategoryReviewMissionCard/PlaceCategoryReviewMissionCard'
import ProfileBorderMissionCard from './ProfileBorderMissionCard/ProfileBorderMissionCard'
import ReceiptReviewMissionCard from './ReceiptReviewMissionCard/ReceiptReviewMissionCard'
import { isReceiptReviewMissionGroup } from './ReceiptReviewMissionCard/ReceiptReviewMissionCard.helper'
import RegionReviewMissionCard from './RegionReviewMissionCard/RegionReviewMissionCard'
import BannerBestReviewer from '../MissionHome/MissionHomeContent/banner/BannerBestReviewer'

export enum MissionBannerType {
  BEST_REVIEWER = 'BEST_REVIEWER',
}
interface MissionBanner {
  bannerType: MissionBannerType
  weight: number
}

interface Props {
  cards: Array<MissionCardProps | MissionBanner>
}
const MissionActivityCard = ({ cards }: Props) => {
  const isMissionCard = (card: MissionCardProps | MissionBanner): card is MissionCardProps => {
    return 'missionGroupType' in card
  }

  const isMissionBanner = (card: MissionCardProps | MissionBanner): card is MissionBanner => {
    return 'bannerType' in card
  }

  return (
    <>
      {cards
        .sort((a, b) => {
          const AmissionCompleteDateTime = isMissionCard(a) ? MissionCard.getMissionCompleteDateTime(a) : null
          const BmissionCompleteDateTime = isMissionCard(b) ? MissionCard.getMissionCompleteDateTime(b) : null

          if (AmissionCompleteDateTime === BmissionCompleteDateTime) {
            return b.weight - a.weight
          }

          if (AmissionCompleteDateTime && BmissionCompleteDateTime) {
            if (AmissionCompleteDateTime.isAfter(BmissionCompleteDateTime, 'second')) return -1

            if (AmissionCompleteDateTime.isBefore(BmissionCompleteDateTime, 'second')) return 1
          }

          return 0
        })
        .map(card => {
          if (isMissionCard(card)) {
            if (card.missionGroupType === MissionGroupType.ProfileBorder) {
              return <ProfileBorderMissionCard missionCard={card} key={card.id} />
            }

            if (isReceiptReviewMissionGroup(card)) {
              return <ReceiptReviewMissionCard missionCard={card} key={card.id} />
            }

            if (card.missionGroupType === MissionGroupType.ReviewLottery) {
              return <LotteryReceiptReviewMissionCard missionCard={card} key={card.id} />
            }

            if (card.missionGroupType === MissionGroupType.RegionReview) {
              return <RegionReviewMissionCard missionCard={card} key={card.id} />
            }

            if (card.missionGroupType === MissionGroupType.PlaceCategoryReview) {
              return <PlaceCategoryReviewMissionCard missionCard={card} key={card.id} />
            }

            if (isMediaReviewMissionGroup(card)) {
              return <PhotoReviewMissionCard missionCard={card} key={card.id} />
            }
          }

          if (isMissionBanner(card)) {
            if (card.bannerType === MissionBannerType.BEST_REVIEWER) {
              return <BannerBestReviewer key={card.bannerType} nClickCode={nClicks.mission.GOOD_REVIEWER} />
            }
          }

          return null
        })}
    </>
  )
}

export default MissionActivityCard
